<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 电脑导航 -->
    <div class="header-nav container">
      <!-- 导航logo -->
      <div class="header-nav-logo">
        <img :src="logo" />
      </div>
      <!-- 导航内容 -->
      <div class="header-nav-title">
        <ul v-if="menu.length > 0" class="header-nav-wrapper">
          <li
            v-for="(item, index) in menu"
            :key="index"
            :class="index == navIndex ? 'active' : ''"
            @click="navClick(index, item.title)"
          >
            <div @click="goItem(item.path)" class="item-a">
              {{ item.title }}
              <span
                v-if="item.c_menu.length > 0"
                class="glyphicon glyphicon-menu-down"
              ></span>
              <i class="underline"></i>
            </div>
            <div v-if="item.c_menu.length > 0" class="down-box">
              <div class="down-box-list">
                <div
                  v-for="(i, n) in item.c_menu"
                  :key="n"
                  class="down-box-item"
                >
                  <div class="item-a" @click="goItem(i.path, n + '')">
                    <span></span>
                    {{ i.title }}
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
        <div @click="switchLanguage" class="header-language">
          <img
            v-if="language == 'zh'"
            src="@/assets/img/icon_language.png"
            alt=""
          />
          <img v-else src="@/assets/img/icon_zh.png" alt="" />
          &nbsp;<span>{{ language == "zh" ? "EN" : "中文" }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Header",
  inject: ["reload"],
  props: ["footerIndex"],
  data() {
    return {
      language: localStorage.getItem("language") || "zh",
      logo: require("@/assets/img/logo_black.png"),
      menu: [],

      navIndex: this.footerIndex || sessionStorage.getItem("navIndex") || 0
    };
  },
  beforeMount() {
    console.log(sessionStorage.getItem("navIndex"), "bbbbb");
    this.handleInit();
  },
  watch: {
    footerIndex(n, o) {
      console.log(n, o, "llllllll");
      this.navIndex = n;
    }
  },
  methods: {
    handleInit() {
      this.$post(this.$api.header).then(res => {
        console.log(res);
        if (res.code == 1) {
          this.logo = res.data.logo;
          this.menu = res.data.menu;
        } else {
          console.log(res.msg);
        }
      });
    },
    switchLanguage() {
      if (this.language === "zh") {
        this.language = "en";
      } else {
        this.language = "zh";
      }
      localStorage.setItem("language", this.language);
      this.reload();
    },
    navClick(index, name) {
      this.navIndex = index;
      sessionStorage.setItem("navIndex", index);
    },
    goItem(path, index) {
      console.log(this.$route.path, path, index);
      // if (this.$route.path === path) return;
      if (index) {
        switch (path) {
          case "/product":
            sessionStorage.setItem("productIndex", index);
            break;
          case "/program":
            sessionStorage.setItem("programIndex", index);
            break;
          case "/case":
            sessionStorage.setItem("caseIndex", Number(index) + 1 + "");
            break;
          case "/news":
            sessionStorage.setItem("newsIndex", Number(index) + 1 + "");
            break;
          case "/about":
            sessionStorage.setItem("aboutIndex", Number(index) + 1 + "");
            break;
        }
      } else if (path == '/about') {
        sessionStorage.setItem("aboutIndex", 0);
      }
      if (this.$route.path === path) {
        this.reload();
      } else {
        this.$router.push({ path });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
/* 顶部 */
#header {
  background: #fff;
  transition: all ease 0.6s;
  .header-nav {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    max-width: 1700px;
    height: 160px;
    padding: 25px 0;
    .header-nav-logo {
      width: 292px;
      height: 114px;
      float: left;
      position: relative;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .header-nav-title {
      flex: 1;
      width: 0;
      display: flex;
      align-items: center;
      height: 100%;
      .header-nav-wrapper {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        width: 100%;
        height: 100%;
        margin: 0;
        > li {
          // float: left;
          margin: 0 5px;
          position: relative;
          cursor: pointer;
          > .item-a {
            color: #333;
            font-size: 20px;
            font-weight: 400;
            padding: 40px 10px;
            position: relative;
            .underline {
              display: block;
              position: absolute;
              bottom: -2px;
              left: 50%;
              width: 0;
              height: 2px;
              opacity: 0;
              transition: all 0.6s ease;
              background-color: #febc2f;
            }
            > span {
              font-size: 18px;
              font-weight: 400;
              transition: transform ease 0.5s;
            }
            &:hover {
              /* color: #febc2f; */
              text-decoration: none;
              .underline {
                opacity: 1;
                width: 100%;
                left: 0;
              }
              span {
                transform: rotate(180deg);
              }
            }
          }
          &.active {
            > .item-a {
              /* color: #febc2f; */
              text-decoration: none;
              border-bottom: 2px solid #febc2f;
            }
          }
          .down-box {
            position: absolute;
            top: 115px;
            left: 0;
            // max-width: 400px;
            // min-width: 200px;
            max-height: 0;
            transition: all 0.5s ease;
            overflow: hidden;
            z-index: 999999;
            .down-box-list {
              // width: 100%;
              background: #fff;
              padding: 30px 0 20px;
              .down-box-item {
                // width: 100%;
                font-size: 18px;
                padding: 10px 20px;
                .item-a {
                  display: flex;
                  align-items: center;
                  // justify-content: center;
                  line-height: 40px;
                  color: #333;
                  font-weight: 400;
                  white-space:nowrap;
                  span {
                    width: 15px;
                    height: 2px;
                    background-color: #febc2f;
                    margin-right: 8px;
                  }
                  &:hover {
                    text-decoration: none;
                  }
                }
                &:hover {
                  cursor: pointer;
                  .item-a {
                    color: #febc2f;
                  }
                }
              }
            }
          }
          &:hover {
            .down-box {
              max-height: 450px;
            }
          }
        }
      }
      .header-language {
        display: flex;
        align-items: center;
        font-size: 24px;
        color: #9b9b9b;
        margin-left: 70px;
        cursor: pointer;
        img {
          position: relative;
          top: -1px;
          width: 30px;
          height: 30px;
        }
        span {
          font-weight: 400;
        }
      }
    }
  }
  .header-nav-fixed {
    .header-nav-wrapper {
      line-height: 50px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue